var bbT = window.bbT || (window.bbT = function(k,d){var o=window.BB_T;return o&&o[k]!=null?o[k]:d;});
/* bb-collection-cards.js — categoriepagina's, 2026-09-20 (changelog §46)
   1. Prijsnotatie gelijk: "vanaf" als eigen span (13/400 gedempt) vóór het bedrag (20/700), zowel in de
      retail-prijs van de kaart als in SparkLayers "Vanaf:" (tekstknoop wordt VERPLAATST in een span, niet
      vervangen — SparkLayer (Solid) houdt dezelfde knoop vast).
   2. Vaste rijen ín het SparkLayer-blok via een adoptedStyleSheet op elke <spark-product-card>-shadowRoot:
      prijs 24 · maat 44 · aantal + doosregel 66 · knop 44 · staffel 56, met 8 px ertussen (= 266 px, gelijk aan
      --bb-pc-rows in bb-collection-cards.css). Structurele selectors (:host > div …, :has(select|input|button)),
      géén Tailwind-klassen van SparkLayer.
   3. (vervallen 2026-09-25, changelog §67) Geen "Niet in je prijslijst"-melding en geen herordening meer:
      elke kaart blijft op haar Liquid-plek. "Koopbaar" meten aan wat SparkLayer al gerenderd had hing af van
      de laadsnelheid (vals positief) en Stef wil geen prijsvraag op de kaart.
   Scope: elke [data-bb-cards]-grid. Het script zet geen data-bb-unpriced/-moved/-buyable meer en stuurt geen
   'bb:cards-reordered' (geen lezers in het theme, gemeten 25-09). */
(function () {
  'use strict';
  var grids = Array.prototype.slice.call(document.querySelectorAll('[data-bb-cards]'));
  if (!grids.length) return;

  /* ---------- 1a. retail-prijs "vanaf € 1,23" → <span.bb-pc-van>vanaf</span> € 1,23 ---------- */
  function wrapRetail(el) {
    if (!el || el.getAttribute('data-bb-wrapping') === '1') return;
    var small = el.querySelector('small');
    var txt = '';
    Array.prototype.forEach.call(el.childNodes, function (n) { if (n.nodeType === 3) txt += n.textContent; });
    var m = /^\s*(vanaf)\s+(.+?)\s*$/i.exec(txt);
    if (!m) return;
    el.setAttribute('data-bb-wrapping', '1');
    try {
      Array.prototype.slice.call(el.childNodes).forEach(function (n) { if (n.nodeType === 3 || n.classList && n.classList.contains('bb-pc-van')) el.removeChild(n); });
      var van = document.createElement('span'); van.className = 'bb-pc-van'; van.textContent = bbT('bb.js_bb_collection_cards.vanaf', 'vanaf');
      el.insertBefore(van, small || null);
      el.insertBefore(document.createTextNode(m[2]), small || null);
    } finally { el.removeAttribute('data-bb-wrapping'); }
  }
  grids.forEach(function (g) {
    Array.prototype.forEach.call(g.querySelectorAll('.bb-pcard__price'), function (el) {
      wrapRetail(el);
      new MutationObserver(function () { wrapRetail(el); }).observe(el, { childList: true, characterData: true, subtree: true });
    });
  });

  /* ---------- 2. SparkLayer-blok: rijen + "Vanaf:"-span ---------- */
  var SHEET_CSS = [
    ':host{display:block;font-family:Assistant,sans-serif;color:#0f172a}',
    ':host>div{display:flex;flex-direction:column;gap:0 !important;row-gap:0 !important}',
    /* prijs */
    ':host>div>div:first-child{height:24px;margin:0 0 8px;overflow:visible}',
    ':host>div>div:first-child>div{margin:0;padding:0;display:block}',
    ':host>div>div:first-child p{margin:0;padding:0;font-size:15px;line-height:20px;font-weight:700;color:#0f172a;white-space:nowrap}',   /* 21-09 Stef: 20 -> 15 px */
    ':host>div>div:first-child p .bb-van{font-size:13px;font-weight:400;color:#516071;margin-right:4px}',
    /* groep maat + koopblok */
    ':host>div>div:nth-child(2){display:flex;flex-direction:column;gap:0 !important;row-gap:0 !important}',
    ':host>div>div:nth-child(2)>div:has(select){height:44px;margin:0 0 8px}',
    ':host>div>div:nth-child(2)>div:has(select)>div{height:44px}',
    ':host>div>div:nth-child(2) select{height:44px;padding:0 32px 0 10px;border:1px solid #7a8ea8;border-radius:6px;background:#ffffff;font-size:14px;line-height:42px;font-weight:400;color:#0f172a}',
    ':host>div>div:nth-child(2) select:focus-visible{outline:2px solid #4781d7;outline-offset:1px}',
    /* koopblok zonder maatkeuze: rij 2 leeg laten (40 + 8) */
    ':host>div>div:nth-child(2)>div:first-child:not(:has(select)){margin-top:52px}',
    ':host>div>div:nth-child(2)>div:not(:has(select)){display:flex;flex-direction:column;gap:0 !important;row-gap:0 !important}',
    /* aantal + doosregel: 40 + 4 + 18 = 62 */
    ':host>div>div:nth-child(2)>div:not(:has(select))>div:has(input){height:66px;margin:0 0 8px;overflow:hidden}',
    ':host>div>div:nth-child(2) div:has(>input){height:44px;border:1px solid #7a8ea8;border-radius:6px;overflow:hidden;background:#ffffff}',
    ':host>div>div:nth-child(2) div:has(>input)>button{height:42px;min-width:44px;width:44px;background:#f5f8fc;color:#0f172a}',
    ':host>div>div:nth-child(2) div:has(>input)>input{height:42px;font-size:14px;font-weight:700;color:#0f172a;text-align:center;border-color:#e7eef8}',
    ':host>div>div:nth-child(2)>div:not(:has(select))>div:has(input)>div:not(:has(input)){height:18px;margin-top:4px;font-size:12px;line-height:18px;font-weight:400;color:#516071;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}',
    /* knop: vlak oranje, witte tekst */
    ':host>div>div:nth-child(2)>div:not(:has(select))>div:has(>button){height:44px;margin:0 0 8px}',
    ':host>div>div:nth-child(2)>div:not(:has(select))>div:has(>button)>button{height:44px;width:100%;padding:0 12px;border:0;border-radius:8px;background:#2f6fd0;color:#ffffff;font-size:14px;font-weight:700;line-height:44px;letter-spacing:0;text-transform:none;box-shadow:none;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}',
    ':host>div>div:nth-child(2)>div:not(:has(select))>div:has(>button)>button:hover{background:#2559b8}',
    ':host>div>div:nth-child(2)>div:not(:has(select))>div:has(>button)>button:focus-visible{outline:2px solid #4781d7;outline-offset:2px}',
    /* staffelblok: vaste 56 px, tekst 12 gedempt */
    ':host>div>div:nth-child(2)>div:not(:has(select))>div:has(>p){height:56px;margin:0;padding:0;overflow:visible;font-size:12px;line-height:18px;color:#516071;background:transparent;border:0;box-shadow:none;border-radius:0}',
    ':host>div>div:nth-child(2)>div:not(:has(select))>div:has(>p)>p{margin:0;padding:0;font-size:12px;line-height:18px;color:#0f172a;font-weight:700}',
    ':host>div>div:nth-child(2)>div:not(:has(select))>div:has(>p)>p+p{font-weight:400;color:#516071;max-height:36px;overflow:hidden}',
    ':host>div>div:nth-child(2)>div:not(:has(select))>div:has(>p)>p+p em{font-style:normal;color:#2f7d55}'
  ].join('\n');
  var sheet = null;
  try { sheet = new CSSStyleSheet(); sheet.replaceSync(SHEET_CSS); } catch (e) { sheet = null; }

  function wrapVanaf(sr) {
    var p = sr.querySelector('p');
    if (!p) return;
    Array.prototype.slice.call(p.childNodes).forEach(function (n) {
      if (n.nodeType !== 3 || !/^\s*Vanaf:?\s*$/i.test(n.textContent)) return;
      var span = sr.ownerDocument.createElement('span'); span.className = 'bb-van';
      p.insertBefore(span, n); span.appendChild(n);         /* knoop verplaatsen, niet vervangen */
      n.textContent = bbT('bb.js_bb_collection_cards.vanaf', 'vanaf');
    });
  }
  function styleSpark(sp) {
    var sr = sp.shadowRoot;
    if (!sr) return false;
    if (sheet && sr.adoptedStyleSheets && sr.adoptedStyleSheets.indexOf(sheet) < 0) {
      sr.adoptedStyleSheets = sr.adoptedStyleSheets.concat([sheet]);
    } else if (!sheet && !sr.querySelector('style[data-bb-rows]')) {
      var st = document.createElement('style'); st.setAttribute('data-bb-rows', '1'); st.textContent = SHEET_CSS; sr.appendChild(st);
    }
    if (sp.getAttribute('data-bb-observed') !== '1') {
      sp.setAttribute('data-bb-observed', '1');
      new MutationObserver(function () { wrapVanaf(sr); }).observe(sr, { childList: true, subtree: true });
    }
    wrapVanaf(sr);
    return true;
  }

  /* ---------- 3. late shadowRoots stylen (SparkLayer rendert kaarten asynchroon) ---------- */
  function rendered(sp) { var sr = sp.shadowRoot; return !!(sr && sr.querySelector('div')); }

  var started = false;
  function go() {
    if (started) return; started = true;
    var t0 = Date.now(), lastChange = Date.now(), lastSig = '';
    (function tick() {
      var all = [], sig = '';
      grids.forEach(function (g) {
        Array.prototype.forEach.call(g.querySelectorAll('spark-product-card'), function (sp) {
          styleSpark(sp);
          var r = rendered(sp); all.push(r); sig += r ? 'r' : '-';
        });
      });
      if (sig !== lastSig) { lastSig = sig; lastChange = Date.now(); }
      var allRendered = all.length && all.every(Boolean);
      if ((allRendered && Date.now() - lastChange > 600) || Date.now() - t0 > 8000) return;
      setTimeout(tick, 250);
    })();
  }
  if (window.spark) go();
  window.addEventListener('sparklayer:ready', go);
})();
